import React from 'react'
import { string } from 'prop-types'

import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'

function TypingMessage({ username, avatar }) {
  return (
    <div className="main-content__message main-content__message--recieved">
      <div className="message__header">
        <div className="message-author">
          <span className="author author--small">
            <a href={`/designers/${username}`}>
              <UserAvatar
                size="small"
                img={avatar}
                userName={username}
              />
              <span>{username}</span>
            </a>
          </span>
        </div>
        <span className="message-time u-float-right">now</span>
      </div>

      <div className="card card--flat message__content">
        <p className="message__description">
          {username} is typing
          {' '}
          <span className="typing-dot" /><span className="typing-dot" /><span className="typing-dot" />
        </p>
      </div>
    </div>
  )
}

TypingMessage.propTypes = {
  username: string.isRequired,
  avatar: string.isRequired,
}

export default TypingMessage
